import {
    ContentDetailInfoShell,
    ContentDetailThreeColLayout,
    DetailFilePanel,
    DetailKvListValue,
    DetailPanel,
    DetailKvTable,
    DetailSummaryButton,
    KV_LIST_TYPES,
} from '../../../../components/detailLayout';
import React from "react";
import Th_title from "../../../../components/Th_title";
import {ContentCategory, ContentStatus} from "../../../../constant/CodeSpecNum";
import ReadOnlyInputBasic from "../../../../components/input/ReadOnlyInputBasic";
import {removeIncidents} from "../../../../api/maintenance/IncidentService";
import {useNavigate} from "react-router-dom";
import ApprovalComponent from "../../../settings/approval/new/ApprovalComponent";
import {TaskManager} from "../../shared/TaskManager";
import {MemoList} from "../../../../components/memo/MemoList";
import SimmsDatePicker from "../../../../components/datepicker/SimmsDatePicker";
import {isMobile} from "../../../../components/commonmethod/CommonMethod";

function IncidentInfo({id, incident, assets, handler, statusNumericValue}) {
    const navigate = useNavigate();

    const remove = async () => {
        await removeIncidents({ids: [id]}).then((response) => {
            if (response.status === 200) {
                alert("장애가 정상적으로 삭제되었습니다.");
                navigate("/maintenance/incident");
            }
        });
    };

    const canAccept = incident.auth?.update && statusNumericValue === ContentStatus.PRE_INSERT.statusNumericValue;

    const summaryMeta = [
        incident.incidentCode?.name && `유형 ${incident.incidentCode.name}`,
        incident.number && `번호 ${incident.number}`,
    ].filter(Boolean).join(" · ");

    const requestInfoPanel = (
        <DetailPanel title={"장애요청정보"}>
            <DetailKvTable>
                <tbody>
                    <tr className="asset-detail-kv-row--auto">
                        <Th_title title={"자산목록"} colspan={3} className="fieldset-td relative align-top">
                            <DetailKvListValue items={assets} listType={KV_LIST_TYPES.asset} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"등록일시"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"createdAt"} value={incident.createdAt} />
                        </Th_title>
                        <Th_title title={"등록자"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"createdBy"} value={incident.createdBy} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"수정일시"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"updatedAt"} value={incident.updatedAt} />
                        </Th_title>
                        <Th_title title={"수정자"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"updatedBy"} value={incident.updatedBy} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"장애 제목"} colspan={3} className="fieldset-td">
                            <ReadOnlyInputBasic target={"title"} value={incident.title} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"요청자"} colspan={3} className="fieldset-td">
                            <ReadOnlyInputBasic target={"requester"} value={incident.requester} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"장애유형"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"incidentCode"} value={incident.incidentCode?.name} />
                        </Th_title>
                        <Th_title title={"요청방식"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"incidentRequest"} value={incident.incidentRequest} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"장애구분"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"incidentType"} value={incident.incidentType} />
                        </Th_title>
                        <Th_title title={"장애등급"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"incidentLevel"} value={incident.incidentLevel} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"장애인지"} colspan={3} className="fieldset-td">
                            <ReadOnlyInputBasic target={"incidentAcceptCode"} value={incident.incidentAcceptCode} />
                            <ReadOnlyInputBasic target={"incidentAcceptText"} value={incident.incidentAcceptText} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"장애기간"} colspan={3} className="fieldset-td fieldset-td-input">
                            <div className="web-flex asset-detail-date-range">
                                <SimmsDatePicker time data={incident.incidentStartDate} readonly />
                                <span className="asset-detail-date-range-sep">~</span>
                                <SimmsDatePicker time data={incident.incidentEndDate} readonly />
                            </div>
                        </Th_title>
                    </tr>
                    <tr className="asset-detail-kv-row--auto">
                        <Th_title title={"장애내용"} colspan={3} className="fieldset-td">
                            <div className="align-text-div">{incident.incidentContent}</div>
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"SLA 사용여부"} colspan={3} className="fieldset-td">
                            <ReadOnlyInputBasic target={"useSla"} value={incident.useSla ? "사용함" : "사용 안함"} />
                        </Th_title>
                    </tr>
                    <tr className="asset-detail-kv-row--auto">
                        <Th_title title={"비고"} colspan={3} className="fieldset-td">
                            <div className="align-text-div">{incident.etc}</div>
                        </Th_title>
                    </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    );

    const workflowPanels = (
        <>
            <TaskManager
                data={incident}
                contentCategory={ContentCategory.INCIDENT}
                statusRows={(
                    <>
                        <tr className="asset-detail-kv-row--auto">
                            <Th_title title={"담당자"} colspan={3} className="fieldset-td fieldset-td-input relative align-top">
                                <DetailKvListValue items={handler} listType={KV_LIST_TYPES.user} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"검수자"} colspan={3} className="fieldset-td">
                                <ReadOnlyInputBasic target={"inspector"} value={incident.inspector} />
                            </Th_title>
                        </tr>
                    </>
                )}
            />

        </>
    );

    const asidePanel = (
        <>
            <ApprovalComponent contentId={incident.id} contentCategory={ContentCategory.INCIDENT_PRE_APPROVE} />
            <ApprovalComponent
                contentId={incident.id}
                contentCategory={ContentCategory.INCIDENT_POST_APPROVE}
                title={"사후결재"}
                approvalSeparator={true}
            />
            <DetailFilePanel
                title="첨부"
                isEditing={Boolean(incident.auth?.update)}
                tableInfo={{tableName: "Incident", joinKey: incident.id}}
            />
            <MemoList entityId={incident.id} entityName={"Incident"} />
        </>
    );

    return (
        <ContentDetailInfoShell
            title={incident.title || "장애 상세"}
            meta={summaryMeta || undefined}
            contentId={id}
            contentCategory={ContentCategory.INCIDENT}
            scrollMode="columns"
            listUrl="/maintenance/incident"
            actions={
                canAccept ? (
                    <DetailSummaryButton onClick={() => navigate(`/maintenance/incident/update/${id}`)}>
                        접수하기
                    </DetailSummaryButton>
                ) : null
            }
            rollup={{
                remove: !isMobile && incident.auth?.delete && statusNumericValue !== ContentStatus.COMPLETE.statusNumericValue ? remove : "",
            }}
        >
            <ContentDetailThreeColLayout
                primary={requestInfoPanel}
                secondary={workflowPanels}
                aside={asidePanel}
            />
        </ContentDetailInfoShell>
    );
}

export {IncidentInfo};
